import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export default class HideOnScroll {
	constructor(element) {
		this.element = element;
		this.tolerance = element.dataset.tolerance;
		this.breakpoint = element.dataset.breakpoint;
		this.buttonRegister = document.querySelector('.js-button-register');
		this.init();
	}

	init() {
		const mm = gsap.matchMedia();

		mm.add(this.breakpoint, () => {
			ScrollTrigger.observe({
				target: window,
				type: 'scroll',
				tolerance: this.tolerance,
				onUp: () => {
					this.element.classList.remove('hide-on-scroll');
					if (window.scrollY === 0) {
						this.element.classList.remove('menu-show');
						if (this.buttonRegister) {
							this.buttonRegister.classList.remove('menu-show');
					  }
					} else {
						this.element.classList.add('menu-show');
						if (this.buttonRegister) {
							this.buttonRegister.classList.add('menu-show');
					  }
					}
				},
				onDown: () => {
					this.element.classList.add('hide-on-scroll');
					this.element.classList.remove('menu-show');
					if (this.buttonRegister) {
						this.buttonRegister.classList.remove('menu-show');
				  }
				},
			});

			return () => {
				this.element.classList.remove('hide-on-scroll');
				this.element.classList.remove('menu-show');
				if (this.buttonRegister) {
					this.buttonRegister.classList.remove('menu-show');
			  }
			};
		});
	}
}
